module.exports = Jsw.skinUrl + "/images/sticker-collection/burst/coin_02.png?6af9c34a365a91a43dcac34370d6073f";